/** Portfolio deep-link for cheat-sheet artefact review. */

export function portfolioPath(portfolioId: string): string {
  return `/portfolio/${portfolioId}`;
}

export function artefactPlanLabel(artefact: {
  plan_name?: string | null;
  plan_id?: string | null;
  title?: string;
}): string {
  return artefact.plan_name?.trim() || artefact.plan_id?.trim() || artefact.title?.trim() || "Portfolio";
}
